module.exports = __webpack_public_path__ + "4e99050ba2f56eee01a4c10f2859bb4d.MP3";